<template>
  <!-- 还款订单 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="form.User" />
        </a-form-item>
        <a-form-item label="IP">
          <a-input v-model="form.IP" />
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker :default-value="[
              moment(getMindatetime(), dateFormat),
              moment().endOf('week'),
            ]" show-time :format="dateFormat" @change="onChange" />
        </a-form-item>
        <a-form-item label="订单类型">
          <a-select v-model="form.Sorte" style="width: 120px" @change="qryListAPI">
            <a-select-option value="0"> 倒序</a-select-option>
            <a-select-option value="1"> 正序</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="备注">
          <a-input v-model="form.Memo" />
        </a-form-item>
        <a-form-item v-if="role83">
          <a-button type="primary" @click="search()"><a-icon type="search" /></a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="uploadBtn()">汇入还款订单<a-icon type="upload" /></a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table size="default" row-key="ID" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }" :loading="loading" :columns="columns" :data-source="data" :pagination="false" bordered>
      <template slot="title">
        <a-row :gutter="24">
          <a-col :span="5" style="line-height: 30px;width: 280px;">
            还款订单 <span class="fontred">{{ clockNumer }}</span> 秒后刷新
            <a-button type="primary" @click="closeClock()">{{clockName}}</a-button>
          </a-col>
          <a-col style="float: right">
            <template v-if="role274">
              <a href="javascript:;" @click="BatchfailRepayOrder()">
                <a-icon type="close-circle" style="font-size: 22px; "></a-icon>
                <span style="font-size: 15px; ">批量失败还款订单</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template>
              <a href="javascript:;" @click="BatchSuccessRepayOrder()">
                <a-icon type="check-circle" style="font-size: 22px; "></a-icon>
                <span style="font-size: 15px; ">批量成功还款订单</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template v-if="role64">
              <a href="javascript:;" @click="BatchDelete()">
                <a-icon type="delete" style="font-size: 22px; color: red"></a-icon>
                <span style="font-size: 15px; color: red">批量删除</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template v-if="role65">
              <a href="javascript:;" @click="AllDelete()" v-if=false>
                <a-icon type="delete" style="font-size: 22px; color: red"></a-icon>
                <span style="font-size: 15px; color: red">删除所有</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template v-if="role85">
              <a href="javascript:;" @click="BatchLockAPI(1)">
                <a-icon type="lock" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量锁定</span>
              </a>
              &nbsp; &nbsp;
              <a href="javascript:;" @click="BatchLockAPI(2)">
                <a-icon type="unlock" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">批量解锁</span>
              </a>
              &nbsp; &nbsp;
            </template>
            <template v-if="role84">
              <a href="javascript:;" @click="AllExport()">
                <a-icon type="file-excel" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">导出所有数据</span>
              </a>
              &nbsp; &nbsp;
              <a href="javascript:;" @click="QryExport()">
                <a-icon type="file-excel" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">导出筛选数据</span>
              </a>
            </template>
          </a-col>
        </a-row>
      </template>
      <template slot="User" slot-scope="text, record">
        <a @click="UserRoute(record.User)">{{ text }}</a>
      </template>
      <template slot="status" slot-scope="text">
        <span v-if="text == 1">待审核</span>
        <span v-if="text == 2">审核通过</span>
        <span v-if="text == 3">审核未通过</span>
      </template>
      <template slot="fdt" slot-scope="text, record">
        <div v-if="record.Status === 1"><span>提交: </span>{{ text }}</div>
        <div v-if="record.Status !== 1">
          <span>提交: </span>{{ text }}
          <br />
          <span>审核: </span>{{ record.Verify }}
        </div>
      </template>
      <template slot="ImageUrlRender" slot-scope="text, record">
        <template v-if="role83">
          <template v-if="record.ImageUrl != ''">
            <a-tooltip>
              <template slot="title">查看交易截图</template>
              <a href="javascript:;" @click="onIamge(record.ImageUrl)">
                <a-icon type="file-image" style="font-size: 22px"></a-icon>
              </a>
            </a-tooltip>
          </template>
          &nbsp;
        </template>
      </template>
      <template slot="operate" slot-scope="text, record">

        <template v-if="role85">
          <template v-if="record.Locking === ''">
            <a-tooltip>
              <template slot="title"> 锁定 </template>
              <a-popconfirm title="确定要锁定?" @confirm="() => onLock(record)">
                <a href="javascript:;">
                  <a-icon type="lock" style="font-size: 22px"></a-icon>
                </a>
              </a-popconfirm>
            </a-tooltip>
            &nbsp;
          </template>
          <template v-else>
            <template v-if="record.Locking === UserID">
              <a-tooltip>
                <template slot="title"> 解锁 </template>
                <a-popconfirm title="确定要解锁?" @confirm="() => onUnLock(record)">
                  <a href="javascript:;">
                    <a-icon type="unlock" style="font-size: 22px"></a-icon>
                  </a>
                </a-popconfirm>
              </a-tooltip>
              &nbsp;
            </template>
            <template v-else>
              <a-tooltip>
                <template slot="title"> 已锁定 </template>
                <a-icon type="lock" style="font-size: 22px; color: #52c41a"></a-icon>
              </a-tooltip>
              &nbsp;
            </template>
          </template>
        </template>
        <template v-if="role63">
          <template v-if="record.Locking === '' || record.Locking === UserID">
            <a-tooltip>
              <template slot="title"> 编辑 </template>
              <a href="javascript:;" @click="onEdit(record)">
                <a-icon type="edit" style="font-size: 22px"></a-icon>
              </a>
            </a-tooltip>
          </template>
          &nbsp;
        </template>
        <template v-if="role64">
          <a-tooltip>
            <template slot="title"> 删除 </template>
            <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
              <a href="javascript:;">
                <a-icon type="delete" style="font-size: 22px"></a-icon>
              </a>
            </a-popconfirm>
          </a-tooltip>
        </template>

      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination style="float: right" show-size-changer :default-current="pagination.current"
        :total="pagination.total" :show-total="(total) => `共 ${total} 条`" :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange" @showSizeChange="sizeChange" />
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="编辑" @ok="modalOk">
      <a-form-model :model="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="会员账号">
          <a-input v-model="formModel.User" placeholder="会员账号" read-only />
        </a-form-model-item>
        <a-form-model-item label="名字">
          <a-input v-model="formModel.UserName" placeholder="名字" read-only />
        </a-form-model-item>
        <a-form-model-item label="当前欠款额度">
          <a-input v-model="formModel.Restamount" read-only />
        </a-form-model-item>
        <a-form-model-item label="还款金额">
          <a-input v-model="formModel.Money" read-only />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <template v-if="formStatus === 1">
            <a-select v-model="formModel.Status">
              <a-select-option value="1"> 待审核</a-select-option>
              <a-select-option value="2"> 审核通过</a-select-option>
              <a-select-option value="3"> 审核未通过</a-select-option>
            </a-select>
          </template>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="formModel.Memo" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="uploadVisible" title="上传还款" @ok="handleUpload">
      <div style="height: 300px">
        上传后的状态: <a-select style="width: 120px" v-model="importType">
          <a-select-option value="1"> 待审核</a-select-option>
          <a-select-option value="2"> 审核成功</a-select-option>
        </a-select>
        <br><br>
        <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button> <a-icon type="upload" /> 选择文件 </a-button>
        </a-upload> <br>
        <a-button type="primary" @click="dowTemplate">
          下载模板
        </a-button>
        <br><br>
        <div style="color:red">
          **请详阅以下说明!**<br>
          *1.文挡内"还款方式"填写为<u>数字</u>,根据[升级域名]>功能里的[存款类型]编号(ID)做填写<br>
          *2.新增还款如果"超过"该笔会员<b>总未还款金额(当前欠款金额)</b>,将会<u>自动过滤不会新增</u>,可于借还款调整记录查看异常会员<br>
          *3.IP,备注可留空,付款方式留空会预设银行转账<br>
          *4.上传后的状态,选择"审核成功"后系统于上传完将会直接将会员更新统计<br>
        </div>
        </br></br>
      </div>
    </a-modal>
  </a-layout-content>
</template>
<script>
  import XLSX from "xlsx";
  import moment from "moment";
  import { jsonExportSheet, arrayExport } from "../../js/xlsxTool";

  export default {
    data() {
      return {
        /*** 权限
         63	还款订单新增/编辑
          64	还款订单删除
          65	还款订单删除所有
          83	还款订单查询
          84	还款订单导出
          85	还款订单解锁/锁定
         */
        role63: false,
        role64: false,
        role65: false,
        role83: false,
        role84: false,
        role85: false,
        role218: false,
        role274: false,
        UserID: sessionStorage.UserID,
        visible: false, //弹框状态
        formModel: {}, // 弹框字段
        formStatus: 1,
        importType: "2",
        clockNumer: 15,
        clockName: "停止刷新",
        polling: undefined,
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        data: [],
        columns: [
          {
            title: "ID",
            dataIndex: "ID",
            align: "center",
            sorter: (a, b) => a.ID - b.ID,
          },
          {
            title: "用户名",
            dataIndex: "User",
            align: "center",
            scopedSlots: { customRender: "User" },
          },
          {
            title: "姓名",
            dataIndex: "UserName",
            align: "center",
          },
          {
            title: "金额",
            dataIndex: "Money",
            align: "center",
          },
          {
            title: "还款方式",
            dataIndex: "RepayTypeName",
            align: "center",
          },
          {
            title: "IP",
            dataIndex: "IP",
            align: "center",
          },
          {
            title: "状态",
            dataIndex: "Status",
            align: "center",
            scopedSlots: { customRender: "status" },
          },
          {
            title: "备注",
            dataIndex: "Memo",
            align: "center",
          },
          {
            title: "提交时间",
            dataIndex: "Fdt",
            align: "center",
            scopedSlots: { customRender: "fdt" },
          },
          {
            title: "最后修改时间",
            dataIndex: "Ldt",
            align: "center",
          },
          {
            title: "最后修改人",
            dataIndex: "Editor",
            align: "center",
          },
          {
            title: "交易截图",
            dataIndex: "ImageUrlRender",
            align: "center",
            scopedSlots: { customRender: "ImageUrlRender" },
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 30,
          sizeList: ["10", "50", "500", "5000", "10000"],
        },
        selectedRowKeys: [], // 勾选此处配置默认列
        loading: false,
        form: { Status: "1", Sorte: "0" },
        fileList: [],
        uploadVisible: false
      };
    },
    methods: {
      moment,
      //分页页数的改变
      pageNumberChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      //  分页显示条数的变化
      sizeChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      // 搜索
      search() {
        this.pagination.current = 1;
        this.qryListAPI();
      },
      // 查询API
      qryListAPI() {
        this.loading = true;
        this.axios
          .post("/repayorder/getqrylist", {
            User: this.form.User == undefined ? "" : this.form.User,
            IP: this.form.IP == undefined ? "" : this.form.IP,
            Status: this.form.Status,
            Sdate: this.form.Sdate,
            Edate: this.form.Edate,
            Sorte: this.form.Sorte,
            pageindex: this.pagination.current,
            pagesize: this.pagination.pageSize,
            Memo: this.form.Memo == undefined ? "" : this.form.Memo,
          })
          .then((res) => {
            if (res.data) {
              this.pagination.total = res.total;
              this.loading = false;
              this.data = res.data;
            }
          });
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      // 查询时间绑定
      onChange(value, dateString) {
        this.form.Sdate = dateString[0];
        this.form.Edate = dateString[1];
      },
      // 锁定
      onLock(data) {
        this.axios
          .post("/repayorder/batchlock", {
            IDList: [{ ID: data.ID }],
            Status: 1,
          })
          .then((res) => {
            if (res.data) {
              this.$message.success("锁定成功");
              this.qryListAPI();
            }
          });
      },
      // 解锁
      onUnLock(data) {
        this.axios
          .post("/repayorder/batchlock", {
            IDList: [{ ID: data.ID }],
            Status: 2,
          })
          .then((res) => {
            if (res.data) {
              this.$message.success("解锁成功");
              this.qryListAPI();
            }
          });
      },
      // 解锁、锁定API
      BatchLockAPI(type) {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        let msg = type === 1 ? "锁定" : "解锁";
        const that = this;
        this.$confirm({
          title: "订单" + msg,
          content: "您要确定要" + msg + "勾选数据吗?",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ ID: element });
            });
            that.axios
              .post("/repayorder/batchlock", {
                IDList: idList,
                Status: type,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success(msg + "成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      // 删除
      onDelete(data) {
        this.axios
          .post("/repayorder/batchdelete", { IDList: [{ ID: data.ID }] })
          .then((res) => {
            if (res.data) {
              this.$message.success("删除成功");
              this.qryListAPI();
            }
          });
      },
      onIamge(data) {
        window.open("https://check.utlkbck.com/image/" + data);
      },
      // 勾选删除
      BatchDelete() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量删除",
          content: "您要确定要删除勾选数据吗?",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ ID: element });
            });
            that.axios
              .post("/repayorder/batchdelete", {
                IDList: idList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("删除成功");
                  that.qryListAPI();
                  this.selectedRowKeys = [];
                }
              });
          },
        });
      },
      BatchSuccessRepayOrder() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量成功还款订单",
          content: "您要确定要批量成功还款订单吗?,*注意如选到锁定中的非自己的订单将直接跳过",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ ID: element });
            });
            that.axios
              .post("/repayorder/batchsuccessrepayorder", {
                IDList: idList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("修改成功");
                  that.qryListAPI();
                  this.selectedRowKeys = [];
                }
              });
          },
        });
      },
      BatchfailRepayOrder() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量失败还款订单",
          content: "您要确定要批量失败还款订单吗?,*注意如选到锁定中的非自己的订单将直接跳过",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ ID: element });
            });
            that.axios
              .post("/repayorder/batchfailrepayorder", {
                IDList: idList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("修改成功");
                  that.qryListAPI();
                  this.selectedRowKeys = [];
                }
              });
          },
        });
      },
      // 删除所有
      AllDelete() {
        const that = this;
        this.$confirm({
          title: "删除所有",
          content: "您要确定要删除所有数据吗?",
          onOk() {
            that.axios.post("/repayorder/alldelete", {}).then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
          },
        });
      },
      // 编辑
      onEdit(data) {
        this.visible = true;
        this.formModel = { ...data };
        this.formStatus = data.Status;
        this.formModel.Status = "" + data.Status;
      },
      modalOk() {
        this.formModel.RepayType = 0;
        if (this.formStatus === 1 || this.formStatus === 4) {
          if (this.formModel.Status == 2) {
            this.formModel.RepayType = 2;
          } else if (this.formModel.Status == 3) {
            this.formModel.RepayType = 3;
          }
        }
        // 弹框确认动作
        this.axios.post("/repayorder/save", this.formModel).then((res) => {
          if (res.data) {
            this.$message.success("编辑成功");
            this.qryListAPI();
            this.visible = false;
          }
        });
      },
      UserRoute(obj) {
        this.$router.push({
          name: 'user',
          params: {
            name: 'user',
            userid: obj,
          }
        });
      },
      // 数据导出
      DataExport(data) {
        this.axios.post("/repayorder/getqryexport", data).then((res) => {
          if (res.data) {
            if (res.data.length > 0) {
              var sheet = XLSX.utils.json_to_sheet(res.data);
              sheet["A1"].v = "编号";
              sheet["B1"].v = "用户名";
              sheet["C1"].v = "姓名";
              sheet["D1"].v = "金额";
              sheet["E1"].v = "还款方式";
              sheet["F1"].v = "状态";
              sheet["G1"].v = "IP";
              sheet["H1"].v = "备注";
              sheet["I1"].v = "提交时间";
              sheet["J1"].v = "审核时间";
              jsonExportSheet(sheet, this.moment().format("YYYYMMDDhhmmss"));
            } else {
              this.$message.warning("无数据导出!");
            }
          }
        });
      },
      // 导出筛选
      QryExport() {
        const that = this;
        this.$confirm({
          title: "导出",
          content: "确定要导出所有数据吗？",
          onOk() {
            that.DataExport({
              User: that.form.User,
              Sdate: that.form.Sdate,
              Edate: that.form.Edate,
              IP: that.form.IP,
              Status: that.form.Status,
              Memo: that.form.Memo == undefined ? "" : that.form.Memo,
            });
          },
        });
      },
      // 导出所有
      AllExport() {
        const that = this;
        this.$confirm({
          title: "导出",
          content: "确定要导出筛选数据吗？",
          onOk() {
            that.DataExport({
              User: "",
              Sdate: "",
              Edate: "",
              IP: "",
              Status: 0,
              Memo: "",
            });
          },
        });
      },
      //计时
      clockrepay() {
        const routes = this.$route.matched.concat().pop();
        if (routes.name === "repayorder") {
          if (this.clockNumer === 1) {
            this.qryListAPI();
            this.clockNumer = 15;
          } else if (!this.loading) {
            this.clockNumer = this.clockNumer - 1;
          }
        }
      },
      closeClock() {
        if (this.clockNumer !== "--") {
          this.clockName = "启动刷新";
          this.polling = clearInterval(this.polling);
          this.clockNumer = "--";
        }
        else {
          this.clockName = "停止刷新";
          this.polling = self.setInterval(this.clockrepay, 1000);
          this.clockNumer = 15;
        }
      },
      getMindatetime() {
        let time = sessionStorage.RepayMin;
        if (new Date(sessionStorage.RepayMin).getFullYear() == 1900) {
          time = moment().startOf("week").format(this.dateFormat);
        }
        return this.getDate(time, "yyyy-MM-dd HH:mm:ss");
      },
      uploadBtn() {
        this.uploadVisible = true;
        this.fileList = [];
      },
      // 下载模板
      dowTemplate() {
        var aoa = [
          ["账号", "真实姓名", "还款金额", "还款方式", "IP", "备注", "提交时间", "审核时间"],
          ["GTCS01(最长50)", "王小明", "100(整数)", "1(要为数字)", "127.0.0.1", "自动扣款", "2022-04-25 00:00:00", "2022-04-26 10:00:01"]
        ];
        arrayExport(aoa, "还款成功上传模板");
      },
      isExcel(file) {
        return /\.(xlsx|xls|csv)$/.test(file.name);
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        if (!this.isExcel(file)) {
          this.$message.error("仅支持上传.xlsx、.xls、.csv、后缀文件");
          return false;
        }
        this.fileList = [file];
        return false;
      },
      handleUpload() {
        if (this.fileList.length < 1) {
          this.$message.success("请选择文件");
          return;
        }
        console.log("开始上传:" + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());

        const that = this;
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary", cellDates: true });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const header = that.getHeaderRow(worksheet);
            // 改变头部
            //账号 真实姓名 还款金额 还款方式 IP 备注 提交时间 审核时间
            worksheet["A1"].w = "User";
            worksheet["B1"].w = "UserName";
            worksheet["C1"].w = "Money";
            worksheet["D1"].w = "RepayType";
            worksheet["E1"].w = "IP";
            worksheet["F1"].w = "Memo";
            worksheet["G1"].w = "Ldt";
            worksheet["H1"].w = "Verify";
            var results = XLSX.utils.sheet_to_json(worksheet);

            console.log("上传文件获取josn:" + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());
            this.generateData({ header, results });
            resolve();
          };
          reader.readAsArrayBuffer(that.fileList[0]);
        });
      },
      generateData({ header, results }) {
        //进行上传
        console.log("开始回圈:" + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());
        results.forEach(element => {
          element["Ldt"] = moment(element["Ldt"]).format("yyyy-MM-DD HH:mm:ss");
          element["Verify"] = moment(element["Verify"]).format("yyyy-MM-DD HH:mm:ss");
        });
        console.log("结束回圈、开始导入:" + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());

        this.axios.post("/repayorder/importrepayorder",
          { Type: this.importType, RepayOrderLists: results }
        ).then((res) => {
          if (res.data) {
            this.fileList = [];
            console.log("导入完成:" + new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds());
            this.mymessage(this, "导入成功");
          }
        });
      },
      getHeaderRow(sheet) {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        let C;
        const R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
          let hdr = "UNKNOWN " + C;
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
          headers.push(hdr);
        }
        return headers;
      },
    },
    //首次加载
    created() {
      // 初始化时间
      this.form.Sdate = this.getMindatetime(); //moment().startOf("week").format(this.dateFormat);
      this.form.Edate = moment().endOf("week").format(this.dateFormat);
      this.qryListAPI();
      this.polling = self.setInterval(this.clockrepay, 1000);//获取权限
      const array = JSON.parse(sessionStorage.RoleID);
      const roleID = [63, 64, 65, 83, 84, 85, 274];
      var isRole = roleID.filter(function (item) {
        return array.indexOf(item) != -1
      });
      //功能权限获取
      isRole.forEach(element => {
        this["role" + element] = true;
      });
    },
  };
</script>

<style>
  .fontred {
    color: #ff4d4f;
    font-size: 15px;
    font-weight: 600;
  }
</style>


// WEBPACK FOOTER //
// src/components/ordermanage/repayorder.vue